<template>
  <div>
    <h1 class="page-title">Interview Videos</h1>
    <div class="row">
      <div class="small-12 columns" style="background-color:blue;">
        <table style="width:100%;">
          <thead>
            <tr>
              <th>COHORT</th>
              <th>USER EMAIL</th>

              <th>QUESTION NAME</th>
              <th>STARS</th>
              <th>TIMESTAMP</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(video, i) in videoLinks" :key="i">
              <td>{{ video.cohort_name }}</td>
              <td>{{ video.email }}</td>
              <td>{{ video.question_name }}</td>
              <td>
                {{
                  video.attempt_data.reviews.length
                    ? video.attempt_data.reviews[0].is_admin
                      ? video.attempt_data.reviews[0].stars
                      : "NA"
                    : "NA"
                }}
              </td>
              <td>{{ video.created_on }}</td>
              <td>
                <span class="play-button" @click="goToVideo(video)">Play</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="loading" class="loader">Loading...</div>
    <div class="video-model" :class="{ 'show-video-model': showVideoModel }">
      <h2 v-if="showVideoModel">{{ openedVideo.question_name }}</h2>
      <div class="small-12 columns">
        <div class="small-6 columns">
          <video class="video-player" controls></video>
          <div>
            <input
              v-model="playBackSpeed"
              class="slider"
              type="range"
              min="1"
              max="10"
              step="1"
              value="1"
              @change="updatePlayBackSpeed"
            />
            <span>{{ playBackSpeed }}</span>
          </div>
        </div>
        <button @click="toggleWindow">
          {{ showDescription ? "Show Review" : "Show Question" }}
        </button>
        <div
          v-if="showDescription"
          class="small-4 columns markdown-body"
          style="overflow-y: scroll; height:300px;"
        >
          <vue-markdown :source="openedVideo.content"></vue-markdown>
        </div>
        <div v-else class="small-4 columns">
          <h3 v-if="openedVideo.attempt_data && openedVideo.attempt_data.notes">
            Notes
          </h3>
          <div class="notes-container">
            <p
              v-if="showVideoModel"
              v-html="openedVideo.attempt_data.notes"
            ></p>
          </div>
          <br />
          <form @submit="addReview">
            <label for="stars">Stars</label><br />
            <input
              id="stars"
              v-model="stars"
              type="number"
              min="1"
              max="5"
              placeholder="stars"
            /><br />
            <label for="review">Review</label>
            <div class="comment-editor-container">
              <simplemde v-model="review" uniqueId="edyst-interview-comment" />
            </div>
            <button type="submit">Add Review</button>
          </form>
        </div>
        <div class="close-button" @click="closeVideoModel"><span>X</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown"
import siteConfig from "@/utils/siteConfig"
import simplemde from "@/components/simpleMarkdownEditor/SimpleMarkdown"

export default {
  components: { simplemde, VueMarkdown },
  data() {
    return {
      videoLinks: [],
      showVideoModel: false,
      openedVideo: {},
      skip: 0,
      limit: 10,
      nextSkip: 0,
      loading: false,
      playBackSpeed: 1,
      stars: 1,
      review: "",
      adminReviewExists: false,
      showDescription: true,
    }
  },
  mounted() {
    // current route /interview_videos/:id
    // here id is optional
    // if id is there we need to fetch that specific attempt
    window.onscroll = this.scrollHandler
    if (this.$route.params.id) {
      this.getSingleVideoLink()
    }
    this.getVideoLinks(this.limit, this.skip)
  },
  methods: {
    getVideoLinks(limit, skip) {
      this.loading = true
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/interview_videos?limit=${limit}&skip=${skip}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.videoLinks = this.videoLinks.concat(res.data.videos)

          if (res.data.videos.length === 0) {
            this.loading = false
            return
          }
          this.nextSkip = this.nextSkip + this.limit
        })
        .catch(err => {
          console.error(`failed to fetch videos. Server response ${err}`)
        })
    },
    getSingleVideoLink() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/interview_videos/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.openVideoModel(res.data.video)
          this.loading = false
        })
        .catch(err => {
          console.error(`failed to fetch video. Server response ${err}`)
        })
    },
    updatePlayBackSpeed() {
      const video = document.querySelector("video")
      video.playbackRate = this.playBackSpeed
    },
    goToVideo(video) {
      this.showVideoModel = true
      this.$router.push(`/interview-videos/${video.attempt_id}`)
      this.getSingleVideoLink()
    },
    openVideoModel(video) {
      this.showVideoModel = true
      this.openedVideo = { ...video }
      // if admin is reviewed in past then it is always at index 0
      const firstReview = video.attempt_data.reviews[0]
      if (firstReview && firstReview.is_admin === true) {
        this.review = firstReview.comment
        this.stars = firstReview.stars
        this.adminReviewExists = true
      }
      this.streamVideo(this.openedVideo.link)
    },
    closeVideoModel() {
      this.showVideoModel = false
      this.openedVideo = {}
      this.playBackSpeed = 1
      const video = document.querySelector("video")
      video.src = null
      this.review = ""
      this.stars = 0
      this.$router.replace("/interview-videos")
    },
    async streamVideo(file) {
      const video = document.querySelector("video")
      const response = await fetch(file)
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      video.src = url
      video.playbackRate = this.playBackSpeed
    },
    addReview(e) {
      e.preventDefault()
      const { attempt_data } = this.openedVideo
      if (this.adminReviewExists) {
        // if admin reviews exists, we need to modify
        // existing comment
        attempt_data.reviews[0].comment = this.review
        attempt_data.reviews[0].stars = this.stars
      } else {
        // otherwise add new one at index 0
        const reviewObj = {}
        reviewObj.comment = this.review
        reviewObj.stars = this.stars
        reviewObj.is_admin = true
        // hard coded aneeq's details
        reviewObj.user = {
          user_id: "-LHBJXrBH1QctJb_3nyD",
          name: "Aneeq Dholakia",
          avatar:
            "https://media.licdn.com/dms/image/C5103AQEDEFcysNSikg/profile-displayphoto-shrink_800_800/0?e=1561593600&v=beta&t=XS9YqavcQ8e3bKTVms2_p4pFe891d7W_3skfoXRK_80",
        }
        attempt_data.reviews.unshift(reviewObj)
      }

      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}questions/attempt/${this.openedVideo.user_id}/${this.openedVideo.question_id}/${this.openedVideo.attempt_id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { attempt: attempt_data },
      })
        .then(() => {
          this.$noty.success("Added review successfully")
        })
        .catch(err => {
          this.$noty.error(`Failed to add review. Server responed with ${err}`)
        })
    },
    toggleWindow() {
      this.showDescription = !this.showDescription
    },
    scrollHandler() {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        // fetch videos only when page reached to botttom
        this.getVideoLinks(this.limit, this.nextSkip)
      }
    },
  },
}
</script>

<style scoped>
table {
  background-color: #841111;
}
th,
td {
  text-align: center;
}
input {
  width: 20%;
  margin: 10px;
}
textarea {
  width: 80%;
  margin: 10px;
}

.page-title {
  text-align: center;
}
.play-button {
  padding: 5px 30px;
  border-radius: 15px;
  color: #536dfa;
  background: #fff;
  cursor: pointer;
  transition: 0.3s ease-out;
}
.play-button:hover {
  color: white;
  background: #536dfa;
}
.video-model {
  visibility: hidden;
  position: fixed;
  z-index: 9999999;
  top: 10px;
  left: 25px;
  width: 95%;
  min-height: 400px;
  padding: 30px;
  opacity: 0;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s ease-in-out;
}
.show-video-model {
  visibility: visible;
  opacity: 1;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  border: 1px solid red;
  border-radius: 50%;
  color: red;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.35s ease-in-out;
}
.notes-container {
  overflow-y: scroll;
  max-height: 200px;
}
.close-button:hover {
  color: #ffffff;
  background-color: red;
}
.video-player {
  width: 80%;
}
.loader {
  text-align: center;
}
.slider {
  width: 50%;
}
.comment-editor-container {
  overflow: hidden;
  height: 200px;
}
</style>
